import notifyPromise from "./notifyPromise";
import confirmPromise from "./confirmPromise";

/**
 * wrapAction - wrap a vuex action and trigger a notification based on success or not.
 *
 * Argument source may be from the component data `{data: 'key'}`, or
 * a getter `{getter: 'name'}`, or a function taking the component `vm => vm.foo()`
 *
 * @param {*} action -- a vuex action
 * @param {*} arg -- argument source
 */
export default function wrapAction({
  confirm, // message to confirm action
  action, // The function to call or action to trigger. Required
  arg,     // Optional descriptor for source of argument.
  success, // success message
  error    // TODO error message massager
}) {
  return async function (triggerEvent) {
    let value = resolveArg(this, arg);
    if (confirm) {
      let message = resolveMessage(this, confirm);
      if (!await confirmPromise(triggerEvent.path, message)) {
        console.log('action cancelled');
        return;
      }
    }
    return notifyPromise(
      triggerEvent.path,
      resolveAction(this, action, value),
      success,
      error
    );
  }
}

function resolveArg(vm, arg={}) {
  if (typeof arg === 'function') return arg.call(vm, vm);
  let {data, getter} = arg;
  if (data) return vm[data];
  if (getter) return vm.$store.getters[getter];
  return undefined;
}

function resolveMessage(vm, message) {
  if (typeof message === 'function') return message.call(vm, vm);
  return message;
}

function resolveAction(vm, action, value) {
  if (typeof action === 'string') {
    return vm.$store.dispatch(action, value);
  } else {
    return action.call(vm, value, vm);
  }
}



// WEBPACK FOOTER //
// ./src/lib/bubble/wrapAction.js